"use server";

import { checkHoneypot, checkSubmissionTime, verifyTurnstile } from "@/lib/antispam";
import { getContactInboxEmail } from "@/lib/contact-inbox";
import { Resend } from "resend";

export async function submitActivation(prevState, formData) {
	// Inicializar Resend dentro de la función para evitar errores de módulo
	const resend = new Resend(process.env.RESEND_API_KEY);
	try {
		// Anti-bot: honeypot y tiempo mínimo (trampa silenciosa)
		if (!checkHoneypot(formData) || !checkSubmissionTime(formData)) {
			return {
				success: true,
				message: "¡Solicitud enviada correctamente! Te contactaremos pronto.",
			};
		}

		// Anti-bot: Cloudflare Turnstile
		if (!(await verifyTurnstile(formData))) {
			return {
				success: false,
				error: "Verificación de seguridad fallida. Recarga la página e inténtalo de nuevo.",
			};
		}

		const businessName = formData.get("businessName");
		const businessType = formData.get("businessType");
		const contactName = formData.get("contactName");
		const email = formData.get("email");
		const phone = formData.get("phone") || "No proporcionado";
		const location = formData.get("location");
		const comments = formData.get("comments") || "Sin comentarios";
		const acceptPrivacy = formData.get("acceptPrivacy");

		// Validaciones básicas
		if (!businessName || !businessType || !contactName || !email || !location) {
			return {
				success: false,
				error: "Por favor, completa todos los campos obligatorios.",
			};
		}

		if (!acceptPrivacy) {
			return {
				success: false,
				error: "Debes aceptar la política de privacidad para continuar.",
			};
		}

		// Validar formato de email
		const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
		if (!emailRegex.test(email)) {
			return {
				success: false,
				error: "Por favor, introduce un email válido.",
			};
		}

		// Preparar el contenido del email
		const emailContent = `
Nueva solicitud de activación de Kaizen Feedback

═══════════════════════════════════════════════════

📋 DATOS DEL NEGOCIO
─────────────────────
• Nombre del negocio: ${businessName}
• Tipo de local: ${businessType}
• Ubicación: ${location}

👤 DATOS DE CONTACTO
─────────────────────
• Persona de contacto: ${contactName}
• Email: ${email}
• Teléfono: ${phone}

💬 COMENTARIOS
─────────────────────
${comments}

═══════════════════════════════════════════════════

Plan solicitado: Plan Estándar (Precio de lanzamiento)
Precio: 299 € / año

Próximos pasos:
1. Contactar con el cliente para confirmar
2. Gestionar el pago
3. Preparar y enviar el expositor + tarjetas

═══════════════════════════════════════════════════
`;

		// Enviar email usando Resend
		// TODO: Cambiar a "Kaizen Feedback <noreply@kaizenfeedback.com>" cuando el dominio esté verificado
		const { data, error } = await resend.emails.send({
			from: "Kaizen Feedback <onboarding@resend.dev>",
			to: [getContactInboxEmail()],
			subject: `Nueva solicitud de activación: ${businessName}`,
			text: emailContent,
		});

		if (error) {
			console.error("Resend error:", error);
			return {
				success: false,
				error: "Ha ocurrido un error al enviar la solicitud. Por favor, inténtalo de nuevo.",
			};
		}

		return {
			success: true,
			message: "¡Solicitud enviada correctamente! Te contactaremos pronto.",
		};
	} catch (error) {
		console.error("Activation submission error:", error);
		return {
			success: false,
			error: "Ha ocurrido un error inesperado. Por favor, inténtalo de nuevo más tarde.",
		};
	}
}
